import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Input, Form, FormGroup, FormFeedback, Button, Card, CardBody, Spinner } from 'reactstrap';
import { userActions } from '../../actions';
import '../AuthForm.css';

const ChangePasswordForm = () => {
  const [localPasswordPair, setLocalPasswordPair] = useState({
    currentPassword: '',
    newPassword: ''
  });

  const [submitted, setSubmitted] = useState(false);
  const [loading] = useState(false);

  const dispatch = useDispatch();

  const handleChange = (event) => {
    const { name, value } = event.target;
    setLocalPasswordPair(localPasswordPair => ({
      ...localPasswordPair,
      [name]: value
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setSubmitted(true);

    if (localPasswordPair && localPasswordPair.currentPassword && localPasswordPair.newPassword) {
      dispatch(userActions.changePassword(localPasswordPair.currentPassword, localPasswordPair.newPassword));
    }
  };

  const invalidCurrentPassword = submitted && !localPasswordPair.currentPassword;
  const invalidNewPassword = submitted && !localPasswordPair.newPassword;

  return (
    <div className="auth-wrapper">
      <div className="auth-card">
        <Card>
          <CardBody>
            <div className="auth-header">
              <h2>Change Password</h2>
              <p>Enter your current and new password</p>
            </div>

            <Form onSubmit={handleSubmit} className="auth-form">
              <FormGroup>
                <label className="form-label" htmlFor="currentPassword">Current Password</label>
                <Input
                  invalid={invalidCurrentPassword}
                  name="currentPassword"
                  id="currentPassword"
                  type="password"
                  placeholder="Enter current password"
                  onChange={handleChange}
                />
                <FormFeedback>Please enter your current password.</FormFeedback>
              </FormGroup>

              <FormGroup>
                <label className="form-label" htmlFor="newPassword">New Password</label>
                <Input
                  invalid={invalidNewPassword}
                  name="newPassword"
                  id="newPassword"
                  type="password"
                  placeholder="Enter new password"
                  onChange={handleChange}
                />
                <FormFeedback>Please enter a new password.</FormFeedback>
              </FormGroup>

              <Button color="primary" disabled={loading}>
                {loading ? 'Updating...' : 'Change Password'}
              </Button>

              {loading && (
                <div className="auth-spinner">
                  <Spinner type="grow" />
                </div>
              )}
            </Form>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default ChangePasswordForm;
